var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"border-solid cursor-pointer bg-gray-400 border-gray-200 border-1 inline-flex overflow-hidden",class:[_vm.radiusClass],on:{"click":_vm.handleImageClick}},[_c('img',{staticClass:"h-full w-full",attrs:{"src":_vm.proxiedUrl,"loading":"lazy","alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }